import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import DefaultForm from '../DefaultForm'
import { first } from 'lodash'
import { INSTANCE_TYPE } from 'pages/Administration/constants'
import Loading from '@ublique/components/Loading'
import 'pages/Administration/components/index.scss'
import {
  handleInstanceCloning,
  notifySuccess,
  processInstanceValidation,
  processRoleValidation
} from 'pages/Administration/Tabs/Instances/helpers'
import { createInstanceApi } from 'services/api/administration/instances'

const InstanceCloningModal = ({ open, close, data }) => {
  const { t } = useTranslation('Administration', 'Common')
  const { instanceType, allInstances, roles, selectedRows, gridApi } = data
  const defaultInstance = { instance: {}, role: {}, permissions: [] }

  const [isInstanceInvalid, setIsInstanceInvalid] = useState(false)
  const [isRoleInvalid, setIsRoleInvalid] = useState(false)
  const [isFormInvalid, setIsFormInvalid] = useState(false)

  const [cloningValue, setCloningValue] = useState(defaultInstance)
  const [isLoading, setIsLoading] = useState(false)

  const { cloningInstanceRecord } = useMemo(
    () => createInstanceApi(instanceType),
    [instanceType]
  )

  function getCloningPayload({ instance, role }) {
    const { roleName, ubliqueId } = first(selectedRows)

    const payload = {
      roleFrom: roleName,
      roleTo: role?.label
    }
    if (instanceType === INSTANCE_TYPE.INSTANCE) {
      payload.instanceFrom = ubliqueId
      payload.instanceTo = instance?.value
    } else {
      payload.scenarioIdFrom = ubliqueId
      payload.scenarioIdTo = instance?.value
    }

    return payload
  }

  const onCloningModalSubmit = async () => {
    const role = processRoleValidation(cloningValue, setIsRoleInvalid)
    const instance = processInstanceValidation(
      cloningValue,
      setIsInstanceInvalid
    )
    if (role || instance) return

    const payload = getCloningPayload(cloningValue)
    setIsLoading(true)

    try {
      await cloningInstanceRecord(payload)
      gridApi.deselectAll()
      notifySuccess('Clone', t)
    } catch (err) {
      console.error(err)
      setIsLoading(false)
      close()
    }
    close()
    setIsLoading(false)
  }

  const handleOnCloningChange = useCallback(
    (value) => {
      setCloningValue((prevState) => ({ ...prevState, ...value }))
      processRoleValidation(value, setIsRoleInvalid)
      processInstanceValidation(value, setIsInstanceInvalid)
    },
    [cloningValue]
  )

  useEffect(() => {
    setIsFormInvalid(isRoleInvalid || isInstanceInvalid)
  }, [isRoleInvalid, isInstanceInvalid])

  return (
    <Modal
      open={open}
      id='selectedRowsLength'
      preventCloseOnClickOutside
      className='admin-view'
      modalHeading={t(`Administration:Clone`)}
      primaryButtonText={t('Administration:Clone')}
      secondaryButtonText={t('Common:Cancel')}
      iconDescription={t('Common:Close')}
      primaryButtonDisabled={isFormInvalid}
      onRequestSubmit={onCloningModalSubmit}
      onRequestClose={close}
      onSecondarySubmit={close}
    >
        {isLoading && <Loading />}
        <DefaultForm
          formFields={handleInstanceCloning(
            handleOnCloningChange,
            cloningValue,
            allInstances || [],
            roles || [],
            isRoleInvalid,
            isInstanceInvalid
          )}
          t={t}
        />
    </Modal>
  )
}

export default InstanceCloningModal
